import { render, staticRenderFns } from "./WidgetProfitChart.vue?vue&type=template&id=804c1d04&"
import script from "./WidgetProfitChart.vue?vue&type=script&lang=js&"
export * from "./WidgetProfitChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports